const BASE_URL = "https://e-mandi.onrender.com";
export default BASE_URL;
